import { render } from "./VFMCompare.vue?vue&type=template&id=1d9e3f85&ts=true"
import script from "./VFMCompare.vue?vue&type=script&lang=ts"
export * from "./VFMCompare.vue?vue&type=script&lang=ts"

import "./VFMCompare.vue?vue&type=style&index=0&id=1d9e3f85&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__